import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export type ScrollToTopProps = {
    element: string;
};

export const ScrollToTop = (props: ScrollToTopProps) => {
    const { pathname } = useLocation();

    useEffect(() => {
        const main = document.querySelector(props.element);
        if (main) {
            main.scrollTo(0, 0);
        }
    }, [pathname, props.element]);

    return <></>;
};
